import { createAction, props } from '@ngrx/store'
import { GovernmentBusinessAPIModel, ModuleDashboardAPIModel, PaginatedAPI } from 'src/app/models/api.model'

const actionGovernmentBusinessPrefix = '[government-business]'

export const fetch_dashboard_data = createAction(
  `${actionGovernmentBusinessPrefix} fetch_dashboard_data`,
  props<{ days: number; sortBy: string; sortOrder: string }>()
)
export const fetch_dashboard_data_success = createAction(
  `${actionGovernmentBusinessPrefix} fetch_dashboard_data_success`,
  props<ModuleDashboardAPIModel>()
)

export const save_government_business_action = createAction(
  `${actionGovernmentBusinessPrefix} save_government_business_action`,
  props<{ governmentBusiness: GovernmentBusinessAPIModel; files: File[]; routeTo: string }>()
)

export const save_government_business_success_action = createAction(
  `${actionGovernmentBusinessPrefix} save_government_business_success_action`,
  props<{ governmentBusiness: GovernmentBusinessAPIModel; routeTo: string }>()
)

export const fetch_government_business_details = createAction(
  `${actionGovernmentBusinessPrefix} fetch_government_business_details`,
  props<{ id: string }>()
)

export const fetch_government_business_details_success = createAction(
  `${actionGovernmentBusinessPrefix} fetch_government_business_details_success`,
  props<{ governmentBusiness: GovernmentBusinessAPIModel }>()
)

export const update_government_business_action = createAction(
  `${actionGovernmentBusinessPrefix} update_government_business_action`,
  props<{ governmentBusiness: Partial<GovernmentBusinessAPIModel>; id: string; files: File[]; routeTo: string }>()
)

export const update_government_business_success_action = createAction(
  `${actionGovernmentBusinessPrefix} update_government_business_success_action`,
  props<{ governmentBusiness: Partial<GovernmentBusinessAPIModel>; routeTo: string }>()
)

export const delete_government_business_details = createAction(
  `${actionGovernmentBusinessPrefix} delete_government_business_details`
)

export const load_government_business_summary_action = createAction(
  `${actionGovernmentBusinessPrefix} load_government_business_summary_action`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)
export const load_government_business_summary_success_action = createAction(
  `${actionGovernmentBusinessPrefix} load_government_business_summary_success_action`,
  props<{ governmentBusiness: PaginatedAPI<GovernmentBusinessAPIModel> }>()
)
